import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataviewComponent = _resolveComponent("DataviewComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.templateData.data_view)
      ? (_openBlock(), _createBlock(_component_DataviewComponent, {
          key: 0,
          templateData: _ctx.templateData,
          onRefresh: _ctx.refreshDataview
        }, null, 8, ["templateData", "onRefresh"]))
      : _createCommentVNode("", true)
  ]))
}